import { GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";

const GoogleLoginButton = ({
  onSuccess,
}: {
  onSuccess: (userInfo: any) => void;
}) => {
  const handleSuccess = (credentialResponse: any) => {
    const userInfo = jwtDecode(credentialResponse.credential);
    // Add the token to the user info object
    const userInfoWithToken = {
      ...userInfo,
      token: credentialResponse.credential
    };
    // Pass user info with token to parent component
    onSuccess(userInfoWithToken);
  };

  return (
    <GoogleLogin
      onSuccess={handleSuccess}
      onError={() => console.log("Login Failed")}
    />
  );
};

export default GoogleLoginButton;
